import React, { Fragment } from "react";
import { useRecoilState } from "recoil";
import Header from "./components/Header";
import Panel from "./components/Panel";
import { appThemeSelector } from "./store/selectors";
import Background from "./components/Background";
import "@fortawesome/fontawesome-free/js/all";
import "react-virtualized-select/styles.css";

const App = () => {
  const [theme] = useRecoilState(appThemeSelector);

  return (
    <div className={`${theme.theme[theme.mode].background} w-full h-full font-sans font-normal text-sm relative flex flex-col`}>
      <div className="tooltip"></div>
      <Fragment>
        <div className={`${theme.theme[theme.mode].background} w-full z-50 relative`}>
          <div className="pt-5 pb-5 max-w-screen-lg mx-auto flex flex-row justify-between">
            <Header />
          </div>
        </div>
        <Background>
          <Panel />
        </Background>
      </Fragment>
    </div>
  );
};

export default App;
